import {
  ReferenceItem,
  ReferenceValue,
  ReferenceValueDelimiter,
} from '../../../../../../types/types';
import { isEmptyValue } from '../../../../../../utils/managerUtils';

// True when the bound value already matches the locally selected items, so the
// displayed labels need no reset. A user selection keeps them in sync; an external
// value change (e.g. sequential-edit row switch) does not.
export const isReferenceValueInSync = (
  value: ReferenceValue,
  selectedItems: ReferenceItem[],
  isMultiselect: boolean,
  delimiter: ReferenceValueDelimiter = ','
): boolean => {
  let valueIds: string[];
  if (isEmptyValue(value)) {
    valueIds = [];
  } else if (isMultiselect) {
    valueIds = String(value).split(delimiter);
  } else {
    valueIds = [String(value)];
  }
  const selectedIds = selectedItems.map((item) => String(item.value));

  if (valueIds.length !== selectedIds.length) return false;

  const selectedIdSet = new Set(selectedIds);
  return valueIds.every((id) => selectedIdSet.has(id));
};
